// const url = 'http://192.168.1.53:88/api';//腾宇本地接口
//  const url = 'http://175.27.191.97:8080/api';//线上正式接口1
const url = 'http://49.232.163.2:8080/api'; //线上正式接口2
// const url = 'http://192.168.1.20:802/api'; //董康本地接口
//  const url = 'http://192.168.1.98:5000/api';//董康Linux接口


export default {
    //版本 烨 0 峰 1 姣 2
    version: "0.0.1",
    //网址
    baseUrl: {
        dev: {
            //烨
            xy: [
                //登录 0
                url + '/Login_Register/LoginService',
                //运维管理 1
                url + '/DevOps/GroupService',
                //测试连接 2
                url + '/DataSource/DataConnection',
                //数据接入 3
                url + '/DataSource/DataSource',
                //数据准备 4
                url + '/DataDeal/DataSet',
                //多维分析 5
                url + '/DataDeal/DataView',
                //大屏 6
                url + '/Screen/Screen',
                //快照 7
                url + '/StoryBoard/DataSnapShot'
            ],
            //峰
            cf: [
                //故事板
                url + '/StoryBoard/StoryBoard',
                //中心管控
                url + '/StoryBoard/TeamSharing',
                //快照
                url + '/StoryBoard/DataSnapShot',
                //排他锁
                url + '/StoryBoard/ExclusiveLock',
            ],
            //姣
            jj: []
        },
        pro: {
            //烨
            xy: [
                //登录
                url + '/Login_Register/LoginService',
                //运维管理
                url + '/DevOps/GroupService',
                //测试连接
                url + '/DataSource/DataConnection',
                //数据接入
                url + '/DataSource/DataSource',
                //数据准备
                url + '/DataDeal/DataSet',
                //多维分析
                url + '/DataDeal/DataView',
                //大屏 6
                url + '/Screen/Screen',
                //快照 7
                url + '/StoryBoard/DataSnapShot'
            ],
            //峰
            cf: [
                //故事板
                url + '/StoryBoard/StoryBoard',
                //中心管控
                url + '/StoryBoard/TeamSharing',
                //快照
                url + '/StoryBoard/DataSnapShot',
                //排他锁
                url + '/StoryBoard/ExclusiveLock',
            ],
            //姣
            jj: [],
            wb: [
                url + '/Screen/ScreenLinkSharing',
                url + '/Screen/ScreenSharing',
                url + '/ResourceSharing/Sharing',
                url + '/Users',
                url + '/Users/Payment',
                url + '/DataSource/DataSource'
            ]
        }
    },
    //页面
    routePath: {
        "数据处理": [{
                name: "数据接入",
                path: "/dataSource"
            },
            {
                name: "数据准备",
                path: "/dataSet"
            },
            {
                name: "多维分析",
                path: "/viewSet",
                children: [{
                    name: "新增图表",
                    path: "/createViewDP"
                }, ]
            },
            {
                name: "原生分析",
                path: "/OData",
                children: [{
                    name: "新增图表",
                    path: "/createViewDP2"
                }, ]
            }
        ],
        "综合展现": [{
            name: "模版列表",
            path: "/stencilList",
            children: [{
                    name: "大屏预览",
                    path: "/viewScreen",
                    children: [{
                        name: "大屏配置",
                        path: "/configScreen"
                    }]
                },
                {
                    name: "新增模版",
                    path: "/addStencil",
                }
            ]
        }],
        "中心管控": [{
                name: "共享列表",
                path: "/setContents"
            },
            {
                name: "内容设置",
                path: "/teamSharing"
            },
        ],

        '运维管理': [{
                name: '查找用户',
                path: '/findUser'
            },
            {
                name: '用户列表管理',
                path: '/userList'
            },
        ],

        '项目效益指标评价': [{
            name: "分值列表",
            path: "/benefitList",
            children: [{
                name: "分值可视化",
                path: "/benefitScreen"
            }]
        }],
        "中心管控2": [{
                name: "我的共享",
                path: "/share"
            },
            // {name: "内容设置", path: "/teamSharing"},
        ],
        "联系我们": [{
            name: "联系我们",
            path: "/contact"
        }, ],
        "模型生成": [{
            name: "模型生成",
            path: "/model"
        }, ],
        "自定义报表": [{
            name: "自定义报表",
            path: "/report"
        }, ],
    },
    //图片地址
    // serverRequestUrl: 'http://47.105.165.74:8060/fprojectIMAGE/resources/chartImg/',
    serverRequestUrl: 'http://175.27.191.97:8060/img/', //云服务图片
    // serverRequestUrl: 'http://192.168.1.20:802/CharstTS/img/',//董康本地
    // serverRequestUrl: 'http://192.168.1.98:5000/CharstTS/img/',//董康linux

    //图片地址
    // chartsRequestUrl: 'http://47.105.165.74:8060/fprojectIMAGE/resources/chartsST'
    chartsRequestUrl: 'http://175.27.191.97:8060' //云服务
    // chartsRequestUrl: 'http://192.168.1.20:802/CharstTS'//董康本地
    // chartsRequestUrl: 'http://192.168.1.98:5000/CharstTS'//董康linux
}